import * as React from 'react';
import BPromise from 'bluebird';
import propz from 'propz';
import { AppUser } from '../../../../views/App/App';
import { parse } from 'query-string';
import { History, Location } from 'history';
import { INVITE_KIND, INVITE_TABS, INVITE_TYPE } from '../../../../consts/invite';
import { DATE_INTERVAL, FILTER_TYPE, FIRST_PAGE, LIMIT } from 'Src/consts/table';
import { GENDER } from '../../../../consts/common';
import { AGE_GROUPS } from '../../../../consts/school';
import { TOURNAMENT_GENDER_SERVER_TO_CLIENT_MAPPING } from '../../../../consts/tournament';
import { Grid2 } from '../../../../components/Grid/Grid2';
import { faEnvelopeOpenText } from '@fortawesome/free-solid-svg-icons';
import { GenericSummary } from '../../../../components/GenericSummary/GenericSummary';
import { Loader } from '../../../../components/Loader/Loader';
import { AdminSchoolsEventSchoolInviteSummary } from '../../../../components/AdminSchoolInviteSummary/AdminSchoolsEventSchoolInviteSummary';
import { AdminSchoolsDeclineInvitesModal } from '../../../../components/AdminSchoolsDeclineInvitesInboxModal/AdminSchoolsDeclineInvitesModal';
import { AdminSchoolsTournamentSchoolInviteSummary } from '../../../../components/AdminSchoolInviteSummary/AdminSchoolsTournamentSchoolInviteSummary';
import { SimpleModal } from '../../../../components/SimpleModal/SimpleModal';
import { TournamentBookingSuccessModal } from 'Src/components/TournamentBookingSuccessModal/TournamentBookingSuccessModal';
import { TournamentWaitingListSuccessModal } from 'Src/components/TournamentWaitingListSuccessModal/TournamentWaitingListSuccessModal';
import {
  ColumnDefinition,
  getFilters2,
  getOrder,
  getSearchFilter,
  getSearchOrder,
  getServerFieldSectionWhere,
  isFilterExist2,
  isSortExist,
  TABLE_SORT_DIRECTION
} from '../../../../helpers/table/table';
import { addSchoolTournamentTeam } from '../../../../helpers/service/admin/tournamentTeams';
import { getTeamPlacesLeft, isIndividualTournament } from '../../../../helpers/tournament/tournament';
import { uniqArray } from '../../../../helpers/common/common';
import { isNonTeamSportEvent } from '../../../../helpers/event/event';
import {
  getEventDataToInvite,
  getEventVenueInviteInbox,
  getInviteStatus,
  getSenderNameIfNeedInviteInbox,
  getStartDateFromInvite
} from '../../../../helpers/accessor/accessor';
import {
  declineAdminSchoolsInvites,
  sendCommentsAdminSchoolsInvites,
  getAdminSchoolsAllInboxInvites,
  searchAdminSchoolInvites
} from '../../../../helpers/service/adminSU/schoolInvitesTable';
import { acceptAutoEnrollmentInvite, acceptInvite } from 'Src/helpers/service/admin/invites';
import { isSchoolEventInvite, isSchoolTournamentInvite } from '../../../../helpers/invite/invite';
import { SchoolInvite } from 'Src/models/invite';
import { AcceptTournamentInviteWithoutAutoEnrollmentTeams } from './AcceptTournamentInviteWithoutAutoEnrollmentTeams/AcceptTournamentInviteWithoutAutoEnrollmentTeams';
import { AcceptTournamentInviteWithAutoEnrollmentTeams } from './AcceptTournamentInviteWithAutoEnrollmentTeams/AcceptTournamentInviteWithAutoEnrollmentTeams';
import { getTournamentEventsPublic } from '../../../../helpers/service/public/public';
import { InviteDetailsDrawer } from './InviteDetailsDrawer';
import './SchoolInvitesHub.scss';
import '../Tournaments/TournamentEvents.css';
import '../Tournaments/Tournament/Invite/TournamentInvite.css';

const COLUMNS: ColumnDefinition[] = [
  {
    text: 'Event',
    field: 'event',
    isSort: false,
    type: FILTER_TYPE.NONE,
    accessor: getEventDataToInvite
  },
  {
    text: 'School',
    field: 'name',
    isSort: true,
    type: FILTER_TYPE.TEXT,
    accessor: getSenderNameIfNeedInviteInbox
  },
  {
    text: 'Start time',
    field: 'startTime',
    isSort: false,
    type: FILTER_TYPE.DATE_INTERVAL,
    accessor: getStartDateFromInvite
  },
  {
    text: 'Venue',
    field: 'venue',
    isSort: false,
    type: FILTER_TYPE.NONE,
    accessor: getEventVenueInviteInbox
  },
  {
    text: 'Status',
    field: 'status',
    isSort: true,
    type: FILTER_TYPE.NONE,
    cell: invite => {
      const status = getInviteStatus(invite);
      return (
        <td key="status">
          <span
            className={`schoolInvitesStatus schoolInvitesStatus--${String(status)
              .toLowerCase()
              .replace(/[^a-z0-9]+/g, '-')}`}
          >
            {status}
          </span>
        </td>
      );
    }
  },
  {
    text: '',
    field: 'open',
    isSort: false,
    type: FILTER_TYPE.NONE,
    cell: () => (
      <td key="open" className="schoolInvitesList__openCell">
        <span aria-hidden="true">›</span>
      </td>
    )
  }
];

interface State {
  items: SchoolInvite[];
  currentPage: number;
  selectedItems: SchoolInvite[];
  viewedInvite: SchoolInvite | null;
  sortDirection: TABLE_SORT_DIRECTION;
  sortColumnsName: string;
  isShowFilter: boolean;
  isDataFiltered: boolean;
  filters: any;
  isLoading: boolean;
  isSelectAllChecked: boolean;
  total: number;
  basePath: string;
  commentText: string;

  currentTabIndex: number;
  isInviteDeclineModalOpen: boolean;
  isTournamentInviteWithoutAutoEnrollmentTeamsModalOpen: boolean;
  isTournamentInviteWithAutoEnrollmentTeamsModalOpen: boolean;
  isTournamentInviteWaitingListModalOpen: boolean;
  isTournamentInviteInfoModalOpen: boolean;
  isBookingConfirmedAsWaitingList: boolean;
  bookingConfirmedTournamentName: string;
  tournamentEvents: any[];
  selectedEventIds: string[];
  eventSelectionError: string;
}

interface Props {
  user: AppUser;
  history: History;
  location: Location;
  setNeedUpdate: () => void;
  inviteKind?: string;
}

export class AdminSchoolsInvitesInbox extends React.Component<Props, State> {
  constructor(props) {
    super(props);

    const reviewInvite = propz.get<SchoolInvite | null>(props, ['location', 'state', 'reviewInvite'], null);

    this.state = {
      items: [],
      currentPage: FIRST_PAGE,
      selectedItems: [],
      viewedInvite: reviewInvite,
      sortDirection: '',
      sortColumnsName: '',
      isShowFilter: false,
      isDataFiltered: false,
      filters: {},
      isLoading: false,
      isSelectAllChecked: false,
      total: 0,
      basePath: '',
      commentText: '',

      currentTabIndex: 0,
      isInviteDeclineModalOpen: false,
      isTournamentInviteWithoutAutoEnrollmentTeamsModalOpen: false,
      isTournamentInviteWithAutoEnrollmentTeamsModalOpen: false,
      isTournamentInviteWaitingListModalOpen: false,
      isTournamentInviteInfoModalOpen: false,
      isBookingConfirmedAsWaitingList: false,
      bookingConfirmedTournamentName: '',
      tournamentEvents: [],
      selectedEventIds: [],
      eventSelectionError: ''
    };
  }

  componentDidMount() {
    this.setState({
      isLoading: true
    });

    document.addEventListener('mousedown', this.onFilterOutsideClick);
    this.setItems();
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.onFilterOutsideClick);
  }

  onFilterOutsideClick = (event: MouseEvent): void => {
    const target = event.target as HTMLElement;
    if (
      !this.state.isShowFilter ||
      (target.closest &&
        (target.closest('.gridModernFilterPopover') ||
          target.closest('.gridModernFiltersAnchor') ||
          target.closest('.sit-dp__pop') ||
          target.closest('.sit-cal') ||
          target.closest('[role="dialog"]')))
    ) {
      return;
    }
    this.setState({ isShowFilter: false });
    this.setItems();
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.location.search !== this.props.location.search) {
      this.setState({
        isLoading: true
      });
      this.setItems(nextProps.location.search);
    }
  }

  setItems(locationSearchOverride?: string) {
    const { history, user } = this.props;

    const search = parse(typeof locationSearchOverride === 'string' ? locationSearchOverride : history.location.search);
    const page = typeof search.page !== 'undefined' ? Number(search.page) : FIRST_PAGE;

    let sortDirection: TABLE_SORT_DIRECTION = '';
    let sortColumnsName = '';

    if (typeof search.order === 'string') {
      [sortColumnsName, sortDirection] = search.order.split(':');
    }

    const sortByFieldExist = sortColumnsName !== '';
    const sortDirectionExist = sortDirection !== '';

    const filters = getFilters2(COLUMNS, search);

    const isShowFilter = isFilterExist2(filters);
    const isDataFiltered = isFilterExist2(filters);

    const dateRange = filters.startTime || {};
    const schoolQuery = filters.name || '';

    const searchPromise = searchAdminSchoolInvites(user, 'inbox', {
      page,
      schoolQuery,
      dateFrom: dateRange.from,
      dateTo: dateRange.to,
      kind: this.props.inviteKind,
      sortField: sortColumnsName || 'startTime',
      sortDirection: sortDirection || 'DESC'
    });
    const getItemsPromise = searchPromise.then(result => result.items);
    const getItemsCountPromise = searchPromise.then(result => ({ count: result.count }));

    const promises = [getItemsCountPromise, getItemsPromise];

    return BPromise.all(promises).then(([countObj, items]) => {
      this.setState({
        currentPage: page,
        sortDirection: sortDirection,
        sortColumnsName: sortColumnsName,
        isShowFilter: false,
        isDataFiltered: isDataFiltered,
        filters: filters,
        items: items,
        total: countObj.count,
        basePath: history.location.pathname,
        isLoading: false
      });

      return true;
    });
  }

  setCurrentPageParams = (currentPage: number): void => {
    let search: string[] = [];

    const { filters, sortColumnsName, sortDirection } = this.state;

    if (currentPage !== 1) {
      search.push(`page=${currentPage}`);
    }

    if (isSortExist(sortDirection, sortColumnsName)) {
      search.push(getSearchOrder(sortDirection, sortColumnsName));
    }

    const isFilter = isFilterExist2(filters);

    if (isFilter) {
      search.push(getSearchFilter(filters));
    }

    this.props.history.push({
      pathname: this.state.basePath,
      search: search.join('&')
    });
  };

  onItemClick = (index: number): void => {
    this.setState({ viewedInvite: this.state.items[index], currentTabIndex: 0 });
  };

  onItemSelect = (index: number): void => {
    const { items, selectedItems } = this.state;
    const selectedItem = items[index];

    const selectedItemIndex = selectedItems.findIndex(item => selectedItem.id === item.id);
    let selectedItemsUpdated = [...selectedItems];

    if (selectedItemIndex !== -1) {
      selectedItemsUpdated.splice(selectedItemIndex, 1);
    } else {
      selectedItemsUpdated.push(selectedItem);
    }

    this.setState({
      selectedItems: selectedItemsUpdated,
      currentTabIndex: 0
    });
  };

  onSelectAllOnPageClick = (): void => {
    const { items, selectedItems } = this.state;

    const itemsFiltered = items.filter(item => {
      return selectedItems.every(selectedItem => selectedItem.id !== item.id);
    });

    const nextSelectedItems = [...selectedItems, ...itemsFiltered];

    this.setState({
      selectedItems: nextSelectedItems,
      isSelectAllChecked: true
    });
  };

  onSelectAllClick = (): void => {
    const { selectedItems, filters } = this.state;

    this.setState({
      isLoading: true
    });

    const user = this.props.user;

    const where = {
      ...getServerFieldSectionWhere(filters, { isCorrectTime: true }),
      ...(this.props.inviteKind ? { kind: this.props.inviteKind } : {})
    };

    getAdminSchoolsAllInboxInvites(user, where).then(items => {
      const itemsFiltered = items.filter(item => {
        return selectedItems.every(selectedItem => selectedItem.id !== item.id);
      });

      const nextSelectedItems = [...selectedItems, ...itemsFiltered];

      this.setState({
        selectedItems: nextSelectedItems,
        isSelectAllChecked: true,
        isLoading: false
      });
    });
  };

  onUnselectAllClick = (): void => {
    this.setState({
      selectedItems: [],
      isSelectAllChecked: false,
      isShowFilter: false
    });
  };

  onTableSortClick = (sortField: string): void => {
    const { sortDirection, sortColumnsName, filters } = this.state;

    const order = getOrder(sortField, sortDirection, sortColumnsName);

    let search: string[] = [];
    search.push(`order=${sortField}:${order}`);

    const isFilter = isFilterExist2(filters);

    if (isFilter) {
      search.push(getSearchFilter(filters));
    }

    this.props.history.push({
      pathname: this.state.basePath,
      search: search.join('&')
    });
  };

  onTableFilterChange = (event, filterField: string, options?): void => {
    const filterValue = event.target.value;
    const filters = this.state.filters;
    const currentFilterField = filters[filterField];

    let nextFilters = { ...filters };

    if (options && options.modernRange) {
      nextFilters = { ...nextFilters, [filterField]: options.modernRange };
    } else if (typeof options !== 'undefined') {
      switch (options) {
        case DATE_INTERVAL.FROM:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              from: filterValue
            }
          };
          break;
        case DATE_INTERVAL.TO:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              to: filterValue
            }
          };
          break;
      }
    } else {
      const filter = COLUMNS.find(col => col.field === filterField);
      const filterType = filter.type;

      if (filterType === FILTER_TYPE.MULTISELECT) {
        const options = event.target.options;
        const value = [];
        for (let i = 0; i < options.length; i++) {
          if (options[i].selected) {
            value.push(options[i].value);
          }
        }
        nextFilters = {
          ...nextFilters,
          [filterField]: value
        };
      } else {
        nextFilters = {
          ...nextFilters,
          [filterField]: filterValue
        };
      }
    }

    this.setState({
      filters: nextFilters
    });
  };

  onApplyFilterClick = (): void => {
    const { filters, sortDirection, sortColumnsName } = this.state;
    let search: string[] = [];

    if (isSortExist(sortDirection, sortColumnsName)) {
      search.push(getSearchOrder(sortDirection, sortColumnsName));
    }

    const isFilter = isFilterExist2(filters);

    if (isFilter) {
      search.push(getSearchFilter(filters));
    }

    this.setState({
      selectedItems: [],
      isSelectAllChecked: false
    });

    this.props.history.push({
      pathname: this.state.basePath,
      search: search.join('&')
    });
  };

  onClearFilterClick = (): void => {
    this.setState({
      selectedItems: [],
      isSelectAllChecked: false,
      filters: {},
      isShowFilter: false
    });

    this.props.history.push({
      pathname: this.state.basePath,
      search: ''
    });
  };

  onTableFilterClick = (event): void => {
    event.preventDefault();

    const isShowFilter = this.state.isShowFilter;

    this.setState({
      isShowFilter: !isShowFilter
    });
  };

  onCancelFilterClick = (): void => {
    this.setState({ isShowFilter: false });
    this.setItems();
  };

  acceptEventSchoolInvite = (): void => {
    const { user, history, setNeedUpdate } = this.props;
    const { selectedItems } = this.state;
    const [invite] = selectedItems;
    this.setState({
      isLoading: true
    });

    acceptInvite(user, invite.id)
      .then(res => {
        const isIndividual = isNonTeamSportEvent(invite.event);
        if (isIndividual) {
          history.push({
            pathname: '/events/individualManager',
            search: `event=${invite.eventId}`
          });
        } else {
          history.push({
            pathname: '/events/teamManager',
            search: `event=${invite.eventId}`
          });
        }
      })
      .then(() => {
        setNeedUpdate();
      });
  };

  acceptTournamentSchoolInvite = async (): Promise<void> => {
    const { selectedItems } = this.state;
    const [invite] = selectedItems;

    const tournament = invite.tournament;
    const isAutoEnrollmentTeams = propz.get(tournament, ['isAutoEnrollmentTeams'], false);
    let tournamentEvents: any[] = [];
    if (isIndividualTournament(tournament)) {
      this.setState({ isLoading: true, eventSelectionError: '' });
      const organiserSchoolId = propz.get(tournament, ['schoolUnionId']) || propz.get(tournament, ['schoolId']);
      try {
        tournamentEvents = await getTournamentEventsPublic(organiserSchoolId, invite.tournamentId, {
          where: {}, skip: 0, limit: 3000, order: 'startTime ASC'
        });
      } catch (error) {
        this.setState({ isLoading: false });
        return;
      }
    }

    if (isAutoEnrollmentTeams) {
      this.setState({
        isLoading: false,
        tournamentEvents,
        selectedEventIds: tournamentEvents.map(event => String(event.id || event._id)),
        isTournamentInviteWithAutoEnrollmentTeamsModalOpen: true
      });
    } else {
      this.setState({
        isLoading: false,
        tournamentEvents,
        selectedEventIds: tournamentEvents.map(event => String(event.id || event._id)),
        isTournamentInviteWithoutAutoEnrollmentTeamsModalOpen: true
      });
    }
  };

  getEventSelectionPayload = () => ({ eventIds: this.state.selectedEventIds });

  canSubmitEventSelection = (): boolean => {
    if (this.state.tournamentEvents.length > 0 && this.state.selectedEventIds.length === 0) {
      this.setState({ eventSelectionError: 'Select at least one event to continue.' });
      return false;
    }
    return true;
  };

  onEventSelectionChange = (selectedEventIds: string[]): void => {
    this.setState({ selectedEventIds, eventSelectionError: '' });
  };

  getAcceptInviteCallback(): () => void {
    const { selectedItems } = this.state;
    const [invite] = selectedItems;

    switch (true) {
      case isSchoolEventInvite(invite):
        return this.acceptEventSchoolInvite;
      case isSchoolTournamentInvite(invite):
        return this.acceptTournamentSchoolInvite;
      default:
        return () => {};
    }
  }

  renderInviteTable(): React.ReactNode {
    const {
      items,
      sortDirection,
      sortColumnsName,
      isShowFilter,
      isDataFiltered,
      selectedItems,
      filters,
      isSelectAllChecked,
      currentPage,
      total
    } = this.state;

    const actionItems = [
      {
        itemText: 'Accept',
        onItemClick: selectedItems.length === 1 ? this.getAcceptInviteCallback() : () => {},
        isActive: selectedItems.length === 1
      },
      {
        itemText: 'Decline',
        onItemClick: this.adminSchoolsDeclineInvitesInboxModalOpen,
        isActive: selectedItems.length > 0,
        isDanger: true
      }
    ];

    const filterOptions = {};

    const isTournamentInbox = this.props.inviteKind === INVITE_KIND.TOURNAMENT_SCHOOL_INVITE;

    return (
      <Grid2
        gridTitle={isTournamentInbox ? 'Tournament invites' : 'Fixture invite inbox'}
        gridTitleCount={total}
        isActionsInline={true}
        isCSV={false}
        dataItems={items}
        filters={filters}
        currentPage={currentPage}
        total={total}
        isSelectAllChecked={isSelectAllChecked}
        isDataFiltered={isDataFiltered}
        sortDirection={sortDirection}
        sortColumnsName={sortColumnsName}
        isShowFilter={isShowFilter}
        dataItemsSelected={selectedItems}
        columns={COLUMNS}
        user={this.props.user}
        columnVisibilityKey={isTournamentInbox ? 'tournaments.school.invites.manage' : 'sports-fixtures-invites-inbox'}
        fixedColumnFields={['event', 'open']}
        hiddenColumnToggleFields={['open']}
        toolbarSearchPlaceholder="Search by school…"
        selectionActionsBelow={true}
        emptyText="No invitations in your inbox"
        emptyIcon={faEnvelopeOpenText}
        emptyHint="New fixture and tournament invitations will appear here."
        emptyFilteredText="No inbox invitations match your filters"
        emptyFilteredHint="Try changing or clearing the search and filters to see other invitations."
        actionItems={actionItems}
        options={filterOptions}
        onItemClick={this.onItemClick}
        onItemSelect={this.onItemSelect}
        onSortClick={this.onTableSortClick}
        onApplyFilterClick={this.onApplyFilterClick}
        onClearFilterClick={this.onClearFilterClick}
        onCancelFilterClick={this.onCancelFilterClick}
        onTableFilterChange={this.onTableFilterChange}
        onTableFilterClick={this.onTableFilterClick}
        setCurrentPageParams={this.setCurrentPageParams}
        onSelectAllClick={this.onSelectAllClick}
        onSelectAllOnPageClick={this.onSelectAllOnPageClick}
        onUnselectAllClick={this.onUnselectAllClick}
      />
    );
  }

  isOneItemSelected(): boolean {
    const selectedItems = this.state.selectedItems;
    return selectedItems.length === 1;
  }

  renderSummary(invite?: SchoolInvite): React.ReactNode {
    const summaryInvite = invite || this.state.selectedItems[0];
    if (!summaryInvite) {
      return <div className="font-weight-bold">Select a invite above</div>;
    }

    const { currentTabIndex } = this.state;
    const summaryTabs = this.getSummaryTabs(summaryInvite);

    return (
      <GenericSummary onTabClick={this.onTabClick} tabs={INVITE_TABS} currentTabIndex={currentTabIndex}>
        {summaryTabs}
      </GenericSummary>
    );
  }

  onTabClick = (event, index: number) => {
    event.preventDefault();

    this.setState({
      currentTabIndex: index
    });
  };

  getSummaryTabs(invite: SchoolInvite = this.state.selectedItems[0]): React.ReactNode {
    const { activeSchoolId } = this.props.user;

    const { currentTabIndex } = this.state;
    const messageType = INVITE_TYPE.INBOX;

    switch (currentTabIndex) {
      case 0:
        switch (true) {
          case invite.kind === INVITE_KIND.EVENT_SCHOOL_INVITE:
            return (
              <AdminSchoolsEventSchoolInviteSummary
                invite={invite}
                activeSchoolId={activeSchoolId}
                messageType={messageType}
              />
            );

          case invite.kind === INVITE_KIND.TOURNAMENT_SCHOOL_INVITE:
            return (
              <AdminSchoolsTournamentSchoolInviteSummary
                invite={invite}
                activeSchoolId={activeSchoolId}
                messageType={messageType}
              />
            );
        }
    }
  }

  onAdminSchoolsDeclineInvitesInboxOkClick = (): void => {
    const { selectedItems, commentText } = this.state;
    const { user, setNeedUpdate } = this.props;

    this.setState({
      isLoading: true
    });

    const trimmedComment = commentText.trim();
    const data = {
      text: trimmedComment ? `Rejected by opponent. ${trimmedComment}` : 'Rejected by opponent.'
    };

    const promises = selectedItems.map(invite => {
      return [declineAdminSchoolsInvites(user, invite.id), sendCommentsAdminSchoolsInvites(user, invite.id, data)];
    });
    BPromise.all(promises).then(em => {
      this.setState({
        isInviteDeclineModalOpen: false,
        isLoading: false,
        commentText: '',
        selectedItems: [],
        viewedInvite: null
      });

      this.setItems().then(() => {
        setNeedUpdate();
      });
    });
  };

  onCommentTextChange = (event): void => {
    this.setState({
      commentText: event.target.value
    });
  };

  adminSchoolsDeclineInvitesInboxModalOpen = (): void => {
    this.setState({
      isInviteDeclineModalOpen: true
    });
  };

  onAdminSchoolsDeclineInvitesInboxModalCloseClick = (): void => {
    this.setState({
      isInviteDeclineModalOpen: false
    });
  };

  renderInviteDeclineModal(): React.ReactNode {
    const { isInviteDeclineModalOpen, commentText } = this.state;
    return (
      <AdminSchoolsDeclineInvitesModal
        modalTitle={'Are you sure you want to decline?'}
        commentText={commentText}
        onCommentTextChange={this.onCommentTextChange}
        onCloseClick={this.onAdminSchoolsDeclineInvitesInboxModalCloseClick}
        isOpen={isInviteDeclineModalOpen}
        onSaveClick={this.onAdminSchoolsDeclineInvitesInboxOkClick}
      />
    );
  }

  onCancelTournamentInviteWithoutAutoEnrollmentTeamsClick = () => {
    this.setState({
      isTournamentInviteWithoutAutoEnrollmentTeamsModalOpen: false
    });
  };

  onCancelTournamentInviteWithAutoEnrollmentTeamsClick = () => {
    this.setState({
      isTournamentInviteWithAutoEnrollmentTeamsModalOpen: false
    });
  };

  onAcceptTournamentInviteWithoutAutoEnrollmentTeamsClick = () => {
    if (!this.canSubmitEventSelection()) return;
    const { selectedItems } = this.state;
    const [invite] = selectedItems;
    const { user, setNeedUpdate } = this.props;
    const tournamentName = propz.get(invite, ['tournament', 'name'], '');

    this.setState({
      isLoading: true
    });

    acceptInvite(user, invite.id, this.getEventSelectionPayload())
      .then(res => {
        this.setState({
          isLoading: false,
          isTournamentInviteWithoutAutoEnrollmentTeamsModalOpen: false,
          isTournamentInviteInfoModalOpen: true,
          isBookingConfirmedAsWaitingList: true,
          bookingConfirmedTournamentName: tournamentName
        });
      })
      .then(() => {
        setNeedUpdate();
      });
  };

  onAcceptTournamentInviteWithAutoEnrollmentTeamsClick = (data?): void => {
    if (!this.canSubmitEventSelection()) return;
    const { user, setNeedUpdate } = this.props;
    const { activeSchoolId, activeSchoolName } = user;

    const { selectedItems } = this.state;
    const [invite] = selectedItems;

    const { tournament, id: inviteId, tournamentId } = invite;
    const { autoEnrollmentTeamsSettings, gender: tournamentGender, ages, sportId } = tournament;

    const isAutoEnrollmentToWaitingList = propz.get<boolean>(tournament, ['isAutoEnrollmentToWaitingList'], false);
    const isIndividual = isIndividualTournament(tournament);

    const isMixedTeamsAvailable = propz.get<boolean>(tournament, ['isMixedTeamsAvailable'], false);
    const isGenderMixed = tournamentGender === GENDER.MIXED;
    const gender = isGenderMixed && !isMixedTeamsAvailable ? GENDER.MALE_ONLY : tournamentGender;

    const ageIndex = propz.get(tournament, ['ages', 0], 0);

    const teamPlacesLeft = getTeamPlacesLeft(autoEnrollmentTeamsSettings, ageIndex, gender);
    const autoEnrollmentTeamsSetting = propz.get(autoEnrollmentTeamsSettings, [0]);
    const maximumNumberTeams = propz.get(autoEnrollmentTeamsSetting, ['maximumNumberTeams']);
    const isAllSpacesBooked = isIndividual && maximumNumberTeams === 0 ? false : teamPlacesLeft === 0;

    const isAllGenderAndAgeTeamPlacesLeft = autoEnrollmentTeamsSettings.every(autoEnrollmentTeamsSetting => {
      const maximumNumberTeams = Number(autoEnrollmentTeamsSetting.maximumNumberTeams || 0);
      return maximumNumberTeams === 0 || maximumNumberTeams - autoEnrollmentTeamsSetting.currentNumberTeams > 0;
    });

    let isAllTeamsCountEmpty = true;

    if (typeof data !== 'undefined') {
      for (let key in data) {
        if (key.includes('-students-') || key === 'numberOfStudents') continue;
        const currentTeamsCount = Number(data[key]);
        if (currentTeamsCount !== 0) {
          isAllTeamsCountEmpty = false;
        }
      }
    }

    this.setState({
      isLoading: true
    });

    switch (true) {
      case isAutoEnrollmentToWaitingList: {
        acceptInvite(user, inviteId, this.getEventSelectionPayload()).then(res => {
          this.setState({
            isLoading: false,
            selectedItems: [],
            isSelectAllChecked: false,
            isTournamentInviteWithAutoEnrollmentTeamsModalOpen: false,
            isTournamentInviteInfoModalOpen: true,
            isBookingConfirmedAsWaitingList: true,
            bookingConfirmedTournamentName: tournament.name
          });

          this.setItems().then(() => {
            setNeedUpdate();
          });
        });
        break;
      }
      case isIndividual && !isAllSpacesBooked: {
        acceptAutoEnrollmentInvite(user, inviteId, this.getEventSelectionPayload())
          .then(res => {
            const teamBody = {
              name: activeSchoolName,
              schoolId: activeSchoolId,
              gender: tournamentGender,
              ages: ages,
              sportId: sportId,
              teamType: 'ADHOC',
              ...(Number(tournament.maxPlayersPerTeam) > 0
                ? { numberOfStudents: Number(data && data.numberOfStudents) }
                : {})
            };

            return addSchoolTournamentTeam(user, tournamentId, teamBody);
          })
          .then(res => {
            this.setState({
              isLoading: false,
              isTournamentInviteInfoModalOpen: true
            });
          })
          .then(() => {
            setNeedUpdate();
          });
        break;
      }
      case isIndividual && isAllSpacesBooked: {
        acceptInvite(user, inviteId, this.getEventSelectionPayload()).then(res => {
          this.setState({
            isLoading: false,
            selectedItems: [],
            isSelectAllChecked: false,
            isTournamentInviteWithAutoEnrollmentTeamsModalOpen: false,
            isTournamentInviteInfoModalOpen: true,
            isBookingConfirmedAsWaitingList: true,
            bookingConfirmedTournamentName: tournament.name
          });

          this.setItems().then(() => {
            setNeedUpdate();
          });
        });
        break;
      }
      case !isAllGenderAndAgeTeamPlacesLeft && isAllTeamsCountEmpty: {
        this.setState({
          isLoading: false,
          isTournamentInviteWithAutoEnrollmentTeamsModalOpen: false,
          isTournamentInviteWaitingListModalOpen: true
        });
        break;
      }
      default: {
        let teamsArray = [];

        for (let key in data) {
          if (key.includes('-students-')) continue;
          const [age, gender] = key.split('-');
          const currentTeamsCount = Number(data[key]);
          if (currentTeamsCount > 0) {
            teamsArray.push({
              age: Number(age),
              gender: gender,
              count: Number(data[key])
            });
          }
        }

        let teamName = '';

        const teamsGenderArray = teamsArray.map(team => team.gender);
        const teamsGenderArrayUniq = uniqArray(teamsGenderArray);

        const isGenderMale = tournamentGender === GENDER.MALE_ONLY;
        const isGenderFemale = tournamentGender === GENDER.FEMALE_ONLY;

        const isSomeTeamsWithEqualGender = teamsGenderArray.length !== teamsGenderArrayUniq.length;

        const charArray = 'abcdefghijklmnopqrstuvwxyz'.toUpperCase().split('');

        let teamsDataToPost = [];

        teamsArray.forEach(team => {
          const teamCount = team.count;
          const teamAge = team.age;
          const teamAgeConverted = AGE_GROUPS['U5-U18'][teamAge];
          switch (true) {
            case isGenderMale:
            case isGenderFemale:
              teamName = `${teamAgeConverted}`;
              if (teamCount === 1) {
                teamName = `${teamAgeConverted}`;
                teamsDataToPost.push({
                  name: teamName,
                  schoolId: activeSchoolId,
                  gender: team.gender,
                  ages: [teamAge],
                  isAutoEnrolledTeam: true
                });
              } else {
                for (let i = 0; i < teamCount; i++) {
                  teamName = `${teamAgeConverted} ${charArray[i]}`;
                  teamsDataToPost.push({
                    name: teamName,
                    schoolId: activeSchoolId,
                    gender: team.gender,
                    ages: [teamAge],
                    isAutoEnrolledTeam: true
                  });
                }
              }
              break;

            case !isSomeTeamsWithEqualGender && teamCount === 1:
              teamName = `${teamAgeConverted}`;
              teamsDataToPost.push({
                name: teamName,
                schoolId: activeSchoolId,
                gender: team.gender,
                ages: [teamAge],
                isAutoEnrolledTeam: true
              });
              break;
            case !isSomeTeamsWithEqualGender && teamCount > 1:
              for (let i = 0; i < teamCount; i++) {
                teamName = `${teamAgeConverted} ${charArray[i]}`;
                teamsDataToPost.push({
                  name: teamName,
                  schoolId: activeSchoolId,
                  gender: team.gender,
                  ages: [teamAge],
                  isAutoEnrolledTeam: true
                });
              }
              break;
            case isSomeTeamsWithEqualGender && teamCount === 1:
              teamName = `${teamAgeConverted} ${TOURNAMENT_GENDER_SERVER_TO_CLIENT_MAPPING[team.gender]}`;
              teamsDataToPost.push({
                name: teamName,
                schoolId: activeSchoolId,
                gender: team.gender,
                ages: [teamAge],
                isAutoEnrolledTeam: true
              });
              break;
            case isSomeTeamsWithEqualGender && teamCount > 1:
              for (let i = 0; i < teamCount; i++) {
                teamName = `${teamAgeConverted} ${TOURNAMENT_GENDER_SERVER_TO_CLIENT_MAPPING[team.gender]} ${
                  charArray[i]
                }`;
                teamsDataToPost.push({
                  name: teamName,
                  schoolId: activeSchoolId,
                  gender: team.gender,
                  ages: [teamAge],
                  isAutoEnrolledTeam: true
                });
              }
              break;
          }
        });

        const nextTeamIndexByCategory: Record<string, number> = {};
        teamsDataToPost.forEach(team => {
          const categoryKey = `${team.ages[0]}-${team.gender}`;
          const teamIndex = nextTeamIndexByCategory[categoryKey] || 0;
          if (Number(tournament.maxPlayersPerTeam) > 0) {
            team.numberOfStudents = Number(data[`${categoryKey}-students-${teamIndex}`]);
          }
          nextTeamIndexByCategory[categoryKey] = teamIndex + 1;
        });

        acceptAutoEnrollmentInvite(user, inviteId, this.getEventSelectionPayload())
          .then(res => BPromise.all(teamsDataToPost.map(team => addSchoolTournamentTeam(user, tournamentId, team))))
          .then(() => {
            this.setState({
              isLoading: false,
              isTournamentInviteWithAutoEnrollmentTeamsModalOpen: false,
              isTournamentInviteInfoModalOpen: true,
              isBookingConfirmedAsWaitingList: false
            });
          })
          .then(() => {
            setNeedUpdate();
          });
      }
    }
  };

  renderTournamentInviteWithoutAutoEnrollmentTeamsModal(): React.ReactNode {
    const { isTournamentInviteWithoutAutoEnrollmentTeamsModalOpen, selectedItems, tournamentEvents, selectedEventIds, eventSelectionError } = this.state;
    const [invite] = selectedItems;
    const { user } = this.props;

    return (
      <SimpleModal
        isOpen={isTournamentInviteWithoutAutoEnrollmentTeamsModalOpen}
        showHeader={false}
        customClass="tournamentBookingModalDialog"
        bodyClassName="tournamentBookingModalHost"
        dialogStyle={{ maxWidth: 680 }}
        onBackdropClick={this.onCancelTournamentInviteWithoutAutoEnrollmentTeamsClick}
      >
        <AcceptTournamentInviteWithoutAutoEnrollmentTeams
          onCancel={this.onCancelTournamentInviteWithoutAutoEnrollmentTeamsClick}
          onAccept={this.onAcceptTournamentInviteWithoutAutoEnrollmentTeamsClick}
          invite={invite}
          user={user}
          events={tournamentEvents}
          selectedEventIds={selectedEventIds}
          eventSelectionError={eventSelectionError}
          onEventSelectionChange={this.onEventSelectionChange}
        />
      </SimpleModal>
    );
  }

  renderTournamentInviteWithAutoEnrollmentTeamsModal(): React.ReactNode {
    const { isTournamentInviteWithAutoEnrollmentTeamsModalOpen, selectedItems, tournamentEvents, selectedEventIds, eventSelectionError } = this.state;
    const [invite] = selectedItems;
    const { user } = this.props;
    return (
      <SimpleModal
        isOpen={isTournamentInviteWithAutoEnrollmentTeamsModalOpen}
        showHeader={false}
        customClass="tournamentBookingModalDialog"
        bodyClassName="tournamentBookingModalHost"
        dialogStyle={{ maxWidth: 820 }}
        onBackdropClick={this.onCancelTournamentInviteWithAutoEnrollmentTeamsClick}
      >
        <AcceptTournamentInviteWithAutoEnrollmentTeams
          onCancel={this.onCancelTournamentInviteWithAutoEnrollmentTeamsClick}
          onAccept={this.onAcceptTournamentInviteWithAutoEnrollmentTeamsClick}
          invite={invite}
          user={user}
          events={tournamentEvents}
          selectedEventIds={selectedEventIds}
          eventSelectionError={eventSelectionError}
          onEventSelectionChange={this.onEventSelectionChange}
        />
      </SimpleModal>
    );
  }

  onTournamentInviteWaitingListModalCloseClick = () => {
    this.setState({
      isTournamentInviteWaitingListModalOpen: false,
      isTournamentInviteWithAutoEnrollmentTeamsModalOpen: true
    });
  };

  acceptTournamentInviteWaitingList = () => {
    if (!this.canSubmitEventSelection()) return;
    const { user } = this.props;
    const { selectedItems } = this.state;
    const [invite] = selectedItems;
    const { id: inviteId } = invite;
    const tournamentName = propz.get(invite, ['tournament', 'name'], '');

    this.setState({
      isLoading: true
    });

    acceptInvite(user, inviteId, this.getEventSelectionPayload()).then(res => {
      this.setState({
        isLoading: false,
        selectedItems: [],
        isSelectAllChecked: false,
        isTournamentInviteWaitingListModalOpen: false,
        isTournamentInviteInfoModalOpen: true,
        isBookingConfirmedAsWaitingList: true,
        bookingConfirmedTournamentName: tournamentName
      });

      this.setItems();
    });
  };

  renderTournamentInviteWaitingListModalOpen(): React.ReactNode {
    const { isTournamentInviteWaitingListModalOpen } = this.state;

    return (
      <SimpleModal
        isOpen={isTournamentInviteWaitingListModalOpen}
        title={'Warning'}
        body={
          "You haven't specified any teams for the tournament. Your school will not be enrolled to the tournament but will be put on to the waiting list"
        }
        buttonText={'Accept (waiting list)'}
        buttonCancelText={'Cancel'}
        onButtonClick={this.acceptTournamentInviteWaitingList}
        onCloseClick={this.onTournamentInviteWaitingListModalCloseClick}
      />
    );
  }

  renderTournamentInviteInfoModalOpen(): React.ReactNode {
    const {
      isTournamentInviteInfoModalOpen,
      selectedItems,
      isBookingConfirmedAsWaitingList,
      bookingConfirmedTournamentName
    } = this.state;
    const { history } = this.props;

    if (isBookingConfirmedAsWaitingList) {
      return (
        <TournamentWaitingListSuccessModal
          isOpen={isTournamentInviteInfoModalOpen}
          tournamentName={bookingConfirmedTournamentName}
          onClose={() => {
            this.setState(
              {
                isTournamentInviteInfoModalOpen: false,
                isBookingConfirmedAsWaitingList: false,
                bookingConfirmedTournamentName: ''
              },
              () => history.push({ pathname: '/tournaments/waitingList' })
            );
          }}
        />
      );
    }

    if (selectedItems.length !== 1) return null;
    const [invite] = selectedItems;
    const name = propz.get(invite, ['tournament', 'name'], '');

    return (
      <TournamentBookingSuccessModal
        isOpen={isTournamentInviteInfoModalOpen}
        tournamentName={name}
        onClose={() => {
          this.setState({ isTournamentInviteInfoModalOpen: false }, () => {
            history.push({ pathname: '/tournaments/upcoming' });
          });
        }}
      />
    );
  }

  render() {
    const {
      isLoading,
      isInviteDeclineModalOpen,
      isTournamentInviteWithoutAutoEnrollmentTeamsModalOpen,
      isTournamentInviteWithAutoEnrollmentTeamsModalOpen,
      isTournamentInviteWaitingListModalOpen,
      isTournamentInviteInfoModalOpen,
      total
    } = this.state;
    const isTournamentInbox = this.props.inviteKind === INVITE_KIND.TOURNAMENT_SCHOOL_INVITE;

    if (isLoading) {
      return <Loader />;
    }
    const classes =
      isInviteDeclineModalOpen ||
      isTournamentInviteWithoutAutoEnrollmentTeamsModalOpen ||
      isTournamentInviteWithAutoEnrollmentTeamsModalOpen ||
      isTournamentInviteInfoModalOpen ||
      isTournamentInviteWaitingListModalOpen
        ? isTournamentInbox
          ? 'modal-open'
          : 'mt-3 modal-open'
        : isTournamentInbox
        ? ''
        : 'mt-3';

    return (
      <div className={`${classes} schoolInvitesList ${isTournamentInbox ? 'tournamentInvitesManagePage' : ''}`.trim()}>
        {isTournamentInbox ? (
          <header className="tournamentListPageHeader">
            <button type="button" onClick={() => this.props.history.push('/tournaments/invites')}>
              <span aria-hidden="true">←</span> Tournaments
            </button>
            <i aria-hidden="true" />
            <div>
              <small>Tournament inbox</small>
              <h1>Invites</h1>
            </div>
            <b>{total.toLocaleString()}</b>
          </header>
        ) : null}
        {/*Place for render modal windows*/}
        {this.renderInviteDeclineModal()}
        {this.renderTournamentInviteWithoutAutoEnrollmentTeamsModal()}
        {this.renderTournamentInviteWithAutoEnrollmentTeamsModal()}
        {this.renderTournamentInviteWaitingListModalOpen()}
        {this.renderTournamentInviteInfoModalOpen()}
        <div className="row">
          <div className="col-md-12">
            {this.renderInviteTable()}
            {this.state.viewedInvite && (
              <InviteDetailsDrawer
                eventName={getEventDataToInvite(this.state.viewedInvite)}
                date={getStartDateFromInvite(this.state.viewedInvite)}
                schoolName={getSenderNameIfNeedInviteInbox(this.state.viewedInvite)}
                venue={getEventVenueInviteInbox(this.state.viewedInvite)}
                status={getInviteStatus(this.state.viewedInvite)}
                folder={
                  this.props.inviteKind === INVITE_KIND.TOURNAMENT_SCHOOL_INVITE
                    ? 'Tournament invite inbox'
                    : 'Fixture invite inbox'
                }
                onClose={() => this.setState({ viewedInvite: null })}
                actions={
                  <>
                    <button
                      type="button"
                      className="is-danger"
                      onClick={() =>
                        this.setState(
                          { selectedItems: this.state.viewedInvite ? [this.state.viewedInvite] : [] },
                          this.adminSchoolsDeclineInvitesInboxModalOpen
                        )
                      }
                    >
                      Decline
                    </button>
                    <button
                      type="button"
                      onClick={() => {
                        this.setState(
                          { selectedItems: this.state.viewedInvite ? [this.state.viewedInvite] : [] },
                          () => {
                            const acceptInvite = this.getAcceptInviteCallback();
                            acceptInvite();
                          }
                        );
                      }}
                    >
                      Accept
                    </button>
                  </>
                }
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}
